import Button from '@algbra/ui/components/Button/Button'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName } from '@algbra/ui/icons'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import { mapIndexed } from 'rambdax'
import { ReactNode } from 'react'
import { useInView } from 'react-intersection-observer'
import { resolveAsImage } from '@algbra/ui/resolvers'
import styles from './JoinOurTeam.module.scss'
import { navigate } from 'gatsby'

export type ZoneJoinOurTeamProps = {
  __typename: 'StrapiGQL_ComponentZonesJoinOurTeam'
  title: ReactNode
  subtitle: ReactNode
  imageList: GatsbyResolvedAsset[]
  button: Array<ButtonType>
}
export type ButtonType = {
  id: number
  buttonText: string
  buttonLink: { slug: string }
}

export default function ZoneJoinOurTeam({
  title,
  subtitle,
  imageList = [],
  button = [],
}: ZoneJoinOurTeamProps) {
  const { ref, inView } = useInView()
  return (
    <Whitespace type="md" className={styles.wspace}>
      <div
        className={classNames(styles.joinUs, { [styles.inView]: inView })}
        ref={ref}
      >
        <Container className={styles.relativeContent}>
          <Whitespace type="lg" hasAnimation={false}>
            <Row>
              <Column size={12} sm={6} className={styles.content}>
                <Heading level={2} type="lg" className={styles.title}>
                  {title}
                </Heading>
                <FreeText className={styles.lead}>{subtitle}</FreeText>
                {button.map((button, index) => {
                  return (
                    <Button
                      key={index}
                      theme="light"
                      size="small"
                      icon={getIconByName('arrow-right')}
                      onClick={() => navigate(`/${button.buttonLink.slug}/`)}
                    >
                      {button.buttonText}
                    </Button>
                  )
                })}
              </Column>
              <Column size={12} sm={6} className={styles.imageContent}>
                <div className={styles.images}>
                  {mapIndexed(
                    (image, index) => (
                      <GatsbyImage
                        key={`join-us-image-${index}`}
                        image={resolveAsImage(image)}
                        role="presentation"
                        className={classNames(
                          styles.image,
                          styles[`image_${index}`]
                        )}
                        alt=""
                      />
                    ),
                    imageList || []
                  )}
                </div>
              </Column>
            </Row>
          </Whitespace>
        </Container>
      </div>
    </Whitespace>
  )
}
